<template>
  <div>
    <div class="base-wrap clearfix">
      <div class="base-item">
        <em class="label">费用事由：</em>
        <div class="content">
          {{formData.title }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">我方公司：</em>
        <div class="content">
          {{ formData.owner_company_info && formData.owner_company_info.name || '--/--' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">对方公司：</em>
        <div class="content">
          {{ formData.other_company_info && formData.other_company_info.name || '--/--' }}
        </div>
      </div>

      <div class="base-item">
        <em class="label">入账时间：</em>
        <div class="content">
          {{ formData.entry_pay_time || '--/--' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">税前金额：</em>
        <div class="content">
          {{formatNum(formData.sum_money) || '--/--'}}
          <span
            v-if="formData.coin_type">{{ coins.constMap.idMap[formData.coin_type].tailUnit}}</span>
        </div>
      </div>
      <div class="base-item">
        <em class="label">进账税额：</em>
        <div class="content">
          {{ formatNum(formData.income_tax_money) || '--/--' }}
          <span
            v-if="formData.coin_type">{{ coins.constMap.idMap[formData.coin_type].tailUnit}}</span>
        </div>
      </div>
      <div class="base-item">
        <em class="label">币种类型：</em>
        <div class="content" v-if="formData.coin_type">
          {{ coins.constMap.idMap[formData.coin_type].name  || '--/--'}}
        </div>
      </div>
      <div class="base-item">
        <em class="label">总金额：</em>
        <div class="content">
          {{formData.format_sum_money}}
          <span
            v-if="formData.coin_type">{{ coins.constMap.idMap[formData.coin_type].tailUnit}}</span>
        </div>
      </div>
      <div class="base-item">
        <em class="label">备注信息：</em>
        <div class="content">
          {{formData.remark || '--/--'}}
        </div>
      </div>
      <div class="base-item">
        <em class="label">附件：</em>
        <div class="content" v-if="formData.img_keys&& formData.img_keys.length>0">
          <template v-for="img in formData.img_keys">
            <a style="color: #2f78ff;" :key='img.key'
              :href="`/api/base/download?key=${img.key}`"
              target="_blank">{{img.name}}&nbsp;&nbsp;</a>&nbsp;
          </template>
        </div>
        <div class="content" v-else>--/--</div>
      </div>
    </div>
    <div class="split_line">
      <i class="el-icon-price-tag"></i><span>帐单详情</span>
      <div class="line"></div>
    </div>
    <el-table size="mini" :data="billsList"
      style="width: 100%; margin-bottom: 20px;">
      <el-table-column
        prop="id"
        label="编号">
      </el-table-column>
      <el-table-column
        prop="month"
        label="月份">
      </el-table-column>
      <el-table-column
        prop="money"
        label="金额">
        <template slot-scope="scope">
          {{formatNum(scope.row.money)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="currency_code"
        label="币种">
        <!-- <template slot-scope="scope">
          {{scope.row.money}}
          <span
            v-if="formData.coin_type">{{ coins.constMap.idMap[formData.coin_type].tailUnit}}</span>
        </template> -->
      </el-table-column>
      <el-table-column
        label="文件名">
        <template slot-scope="scope">
          <a :href="item.path" target="_blank" :key="index"
            v-for="(item,index) in scope.row.attachments"
            download>{{item.filename}} <br></a>

        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import { coins } from '@/const'
import { getBillDetail } from '@/api/approval'
import { formatNum } from '@/utils/toTx'
export default {
  name: 'confirmCostDetail', // 确认费用
  props: {
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    expenseTypes: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    approveType() {
      return this.$route.query.type
    }
  },
  created() {
    console.log('approveType', this.approveType);
    this.getBillDetailHandler()
  },
  methods: {
    formatNum(num) {
      return formatNum(num)
    },
    getBillDetailHandler() {
      let purchase_bill_ids = this.formData.purchase_bill_ids;
      if (!purchase_bill_ids || purchase_bill_ids.length <= 0) return;
      getBillDetail(purchase_bill_ids).then(res => {
        // console.log(res)
        if (res.code != 0) throw new Error(res.message);
        this.billsList = res.data;

      })
    }
  },
  data() {
    return {
      coins,
      billsList: []
    }
  },
}
</script>
